<template>
  <div id="pdfBox">
	  <div class="pdf">
		  <p>如果未打开请选择发送到您的邮箱</p>
		  <el-input placeholder="请填写邮箱" size="mini" type="text" v-model="email"></el-input>
		  <el-button style='margin: 2.5vh 0;' type="primary" size="mini">发送</el-button>
	  </div>
	  
	  <iframe class="iframe" src="https://mp.dajiuxing.com.cn/pdf/2019/06/05/20190605000002-22152.pdf" frameborder="0"></iframe>
  </div>
</template>
<script>
	export default{
		data(){
			return {
				email:''
			}
		}
	}
</script>
<style>
	.pdfBox{height: 100vh;}
	.pdf{padding: 0 5vw;}
	.pdf p{line-height: 10vh;}
	.iframe{height: 80vh;width: 100vw;overflow: auto;}
</style>



// WEBPACK FOOTER //
// src/views/test.vue